import {URL_BASE_API } from '../configs/urlConfigs' 

import service from './api';

export const currencyList = (request) => {
    const ENDPOINT = URL_BASE_API+'super-admin/currency/';  
    return service.get(ENDPOINT);      
}; 

export const locationSearch = (request) => {
    let location = '';
    if(request.data){
        location = '?location='+request.data;
    }
    const ENDPOINT = URL_BASE_API+'user/locations/'+location;
  
    return service.get(ENDPOINT);  
    
}; 

export const primaryContactList = (request) => {
    let affiliateId = request.data.profileId;
    let userType    = request.data.userType;
    const ENDPOINT  = URL_BASE_API+'user/primary-contacts/?user_type='+userType+'&profile_id='+affiliateId;
    return service.get(ENDPOINT);  
    
};

export const aflt_skillSelList = (request) => {
    const ENDPOINT  = URL_BASE_API+'affiliate/skills-list/';
    return service.get(ENDPOINT); 
};

export const aflt_keyLocationList = (request) => {
    const ENDPOINT  = URL_BASE_API+'affiliate/key-locations-list/';
    return service.get(ENDPOINT); 
};

export const changePassword = (request) => {
    const ENDPOINT  = URL_BASE_API+'user/changepassword/';
    return service.post(ENDPOINT,request.data);  
};

export const resendEmail = (request) => {
    const ENDPOINT  = URL_BASE_API+'user/resend-email-link/'+request.data;
    return service.post(ENDPOINT);  
};

export const getProfileRole = (request) => {
    let profileId   = request.data.profileId;
    let userType    = request.data.userType;
    const ENDPOINT  = URL_BASE_API+'user/profile-roles/?profile_id='+profileId+'&user_type='+userType;
    return service.get(ENDPOINT);  
};

export const departmentList = (request) => {
    let ENDPOINT = '';
    ENDPOINT = URL_BASE_API+'user/departments/'; 
    return service.get(ENDPOINT);    
}; 

export const countryList = (request) => {
    let ENDPOINT = URL_BASE_API+'super-admin/country/'; 
    return service.get(ENDPOINT);    
}; 

export const timeZonesList = (request) => {
    let ENDPOINT = URL_BASE_API+'super-admin/region-timezone/'; 
    return service.get(ENDPOINT);    
};

export const serverTimeList = (request) => {
    let ENDPOINT = URL_BASE_API+'super-admin/server-time/'; 
    return service.get(ENDPOINT);    
};

export const inviteAsFriend = (request) => {
    const ENDPOINT  = URL_BASE_API+'user/invite-friend_v2/';
    return service.post(ENDPOINT,request.data); 
};

export const loginAsUser = (request) => {
    const ENDPOINT  = URL_BASE_API+'login/';
    return service.post(ENDPOINT,request.data); 
};

